import { update as updateUser } from '@/pages/Account/Profile/service';
import { timezoneOptions } from '@/utils/tz';
import { Modal, message } from 'antd';
import { useMemo, useState } from 'react';
import { useModel } from 'umi';

const TimezoneCheckModal = () => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  const isTeacher = currentUser?.hasTeachingProfile === true;

  const browserTimezone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);

  const notSet = isTeacher && browserTimezone && !currentUser?.timezone;
  const mismatch =
    isTeacher && currentUser?.timezone && browserTimezone && currentUser.timezone !== browserTimezone;
  const needCheck = notSet || mismatch;

  const [visible, setVisible] = useState(needCheck);
  const [loading, setLoading] = useState(false);

  const getTzLabel = (tz) => {
    const opt = timezoneOptions.find((o) => o.value === tz);
    return opt ? opt.label : tz;
  };

  const browserTzLabel = useMemo(() => getTzLabel(browserTimezone), [browserTimezone]);
  const currentTzLabel = useMemo(() => getTzLabel(currentUser?.timezone), [currentUser?.timezone]);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await updateUser({ id: currentUser.id, timezone: browserTimezone });
      currentUser.timezone = browserTimezone;
      setInitialState((s) => ({ ...s, currentUser }));
      message.success('时区已更新！');
      setVisible(false);
    } catch {
      message.error('更新时区失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  if (!needCheck) return null;

  return (
    <Modal
      title="时区确认"
      open={visible}
      okText={notSet ? '是，设置时区' : '是，更新时区'}
      cancelText="否，保持不变"
      confirmLoading={loading}
      onOk={handleConfirm}
      onCancel={() => setVisible(false)}
    >
      <p>
        {notSet ? (
          <>
            检测到您尚未设置时区，当前所在时区为 <strong>{browserTzLabel}</strong>
            ，是否设置为该时区？
          </>
        ) : (
          <>
            检测到您当前所在时区为 <strong>{browserTzLabel}</strong>，与账号设置的时区{' '}
            <strong>{currentTzLabel}</strong> 不一致，是否需要更新为<strong>{browserTzLabel}</strong>？
          </>
        )}
      </p>
    </Modal>
  );
};

export default TimezoneCheckModal;
